import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import langAuthDisclaimer from './langs/langAuthDisclaimer';
import CAppDialog from '../../../../app/components/CAppDialog';

type AuthDisclaimerProps = {
	open: boolean;
	onClose: (action?: string) => void;
};
const AuthDisclaimer = (props: AuthDisclaimerProps) => {
	const { open, onClose } = props;

	const { t } = useTranslation();

	return (
		<div>
			<CAppDialog
				open={open}
				id="dialog-disclaimer"
				title={t(langAuthDisclaimer.title.tag)}
				actions={
					<>
						{/* <Button variant="contained" color="primary" onClick={() => onClose('disagree')}>
							{t(langAuthDisclaimer.btn_disagree.tag)}
						</Button> */}
						<Button
							variant="contained"
							color="primary"
							onClick={() => onClose('agree')}
							id="btn-dialog-disclaimer-agree"
							autoFocus
						>
							{t(langAuthDisclaimer.btn_ok.tag)}
						</Button>
					</>
				}
			>
				{t(langAuthDisclaimer.text.tag)}
			</CAppDialog>
			{/* <Dialog
				open={open}
				onClose={() => onClose('close')}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{t(langAuthDisclaimer.title.tag)}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{t(langAuthDisclaimer.text.tag)}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => onClose('disagree')}>{t(langAuthDisclaimer.btn_disagree.tag)}</Button>
					<Button onClick={() => onClose('agree')} autoFocus>
						{t(langAuthDisclaimer.btn_agree.tag)}
					</Button>
				</DialogActions>
			</Dialog> */}
		</div>
	);
};

export default AuthDisclaimer;
